import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
const NAMES = ['Martín', 'Laura', 'Diego', 'Carolina', 'Javier', 'Sofía', 'Pablo', 'Valentina', 'Facundo', 'Camila'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const showPopup = () => {
      setData({
        name: NAMES[Math.floor(Math.random() * NAMES.length)],
        city: CITIES[Math.floor(Math.random() * CITIES.length)]
      });
      setIsVisible(true);
      setTimeout(() => setIsVisible(false), 4000);
    };
    const initial = setTimeout(showPopup, 5000);
    const interval = setInterval(() => {
      setTimeout(showPopup, Math.random() * 5000 + 10000);
    }, 15000);
    return () => {
      clearTimeout(initial);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-142">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-50 bg-[#0a1128] border-2 border-[#2563eb] rounded-xl shadow-2xl p-4 max-w-xs flex items-center gap-4 glow-blue" data-id="element-143">
          <div className="bg-[#2563eb]/20 p-2 rounded-full" data-id="element-144">
            <ShoppingBag className="w-6 h-6 text-[#2563eb]" data-id="element-145" />
          </div>
          <div data-id="element-146">
            <p className="text-sm font-bold text-white" data-id="element-147">
              {data.name} de {data.city}
            </p>
            <p className="text-xs text-[#eab308] font-medium" data-id="element-148">
              acaba de comprar el Kit Completo
            </p>
            <p className="text-[10px] text-gray-500 mt-1" data-id="element-149">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}